// extracted by mini-css-extract-plugin
export var phone = "Contact-module--phone--2eacq";
export var spinAround = "Contact-module--spinAround--3peZd";